"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const emptyData = {
    targetMetric: { name: '', type_code: '' },
    proposal: { proposalId: 0, currentProject: 0, currentAreaID: 0, projects: [] },
    distributions: [],
};
class DistroData {
    constructor(data = emptyData) {
        this.targetMetric = data.targetMetric || emptyData.targetMetric;
        this.proposal = data.proposal || emptyData.proposal;
        this.distributions = data.distributions || emptyData.distributions;
    }
}
exports.default = DistroData;
